import React from 'react';
import { Input } from './TextInput.styled';

// TODO: Extends TextComponent in CL
export interface ITextInput {
   onChange?: any;
   setFocus?: any;
   value?: string;
   placeholder?: string;
   className?: string;
}

const TextInput: React.FC<ITextInput> = props => {
   const { value, setFocus, onChange, placeholder, className } = props;

   return (
      <Input
         value={value}
         placeholder={placeholder}
         onFocus={() => setFocus(true)}
         onBlur={() => setFocus(false)}
         onChange={e => onChange(e.target.value)}
         className={className}
      />
   );
};

export default TextInput;
